import { jwtDecode } from 'jwt-decode';

/**
 * Checks if the given JWT token is valid (i.e., not expired).
 * @param {string} token - The JWT token.
 * @returns {boolean} - True if valid, false otherwise.
 */
export const isTokenValid = (token) => {
    if (!token) return false;
    try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000; // seconds
        return decoded.exp && decoded.exp > currentTime;
    } catch {
        return false;
    }
};

/**
 * Gets the expiration time (in ms) of the token.
 * @param {string} token - The JWT token.
 * @returns {number} - Timestamp (in ms) of token expiration.
 */
export const getTokenExpirationTime = (token) => {
    try {
        const decoded = jwtDecode(token);
        return decoded.exp * 1000; // ms
    } catch {
        return 0;
    }
};
